import React from 'react';

const Vue_Home = () => {
  return (
    <div>
      <h1>Vue_Home Component</h1>
      <p>This is the Vue_Home tutorial page.</p>
    </div>
  );
}

export default Vue_Home;
